import { Box, CircularProgress } from "@mui/material";
import { useAppTheme } from "../../utils/theme";

const Spinner = () => {
	const theme = useAppTheme();
	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			height="240px"
		>
			<CircularProgress sx={{ color: theme.palette.primary.main }} />
		</Box>
	);
};

export default Spinner;
